import {
  Box,
  Button,
  Drawer,
  Grid,
  LinearProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

const EmailCount = () => {
  const theme = useTheme();
  const { currentOrg } = useContext(OrganizationUserContext);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { setUpgradeDialogSource, subscription, plans, emailSents } =
    useContext(SubscriptionContext);

  if (!plans || subscription?.isSubscribed || currentOrg?.isBrand) return <></>;

  const getText = () => {
    if (emailSents > plans[Plans.FREE]?.monthly_limit!) {
      return `${emailSents} emails`;
    }
    return `${emailSents}/${plans[Plans.FREE]?.monthly_limit} emails`;
  };

  const getValue = () => {
    if (emailSents > plans[Plans.FREE]?.monthly_limit!) {
      return 100;
    }
    return (emailSents / (plans[Plans.FREE]?.monthly_limit || 1)) * 100;
  };

  const renderDesktopView = () => {
    return (
      <>
        <Box sx={{ fontSize: 12 }}>
          You've sent <strong>{getText()}</strong> this month.
          <LinearProgress
            variant="determinate"
            value={getValue()}
            sx={{ borderRadius: 4 }}
          />
        </Box>
        <Button
          size="small"
          disableElevation
          variant="contained"
          onClick={() =>
            setUpgradeDialogSource(
              UpgradeDialogSource.top_bar_emails_sent_progress,
            )
          }
          sx={{ borderRadius: 4, fontSize: { xs: 12, md: 14 } }}
        >
          Upgrade to send more
        </Button>
      </>
    );
  };

  const renderMobileView = () => {
    return (
      <Drawer open={true} variant="permanent" anchor={"bottom"}>
        <Box
          sx={{ backgroundColor: "primary.main", p: 2 }}
          onClick={() => {
            setUpgradeDialogSource(
              UpgradeDialogSource.top_bar_emails_sent_progress,
            );
          }}
        >
          <LinearProgress
            variant="determinate"
            value={getValue()}
            sx={{
              borderRadius: 4,
              "& .MuiLinearProgress-bar": { backgroundColor: "yellow.main" },
            }}
          />

          <Grid
            container
            justifyContent="center"
            sx={{ mt: 1 }}
            alignItems={"center"}
            gap={1}
          >
            <Typography
              textAlign={"center"}
              sx={{ color: "white", fontSize: 10 }}
            >
              You've sent <strong>{getText()}</strong> this month.
            </Typography>
            <Button
              sx={{
                color: "yellow.main",
                fontSize: 10,
                borderRadius: 4,
                px: 1,
                border: "1px solid #FFFFAB",
              }}
              size="small"
            >
              Upgrade to send more
            </Button>
          </Grid>
        </Box>
      </Drawer>
    );
  };

  if (isSmallScreen) {
    return renderMobileView();
  } else {
    return renderDesktopView();
  }
};

export default EmailCount;
